/**
 * The view-as banner must stay on screen even when the target has no access at all, so the app shell wraps both the
 * full layout and the no-access page in this frame. It keeps the stored session in step with the backend echo and owns
 * the viewport as a column, so while the echo is present the banner takes its own row above the app and the layout
 * fills only what is left. The column is always rendered so the app below never remounts when the echo arrives.
 */
import React from 'react';
import { ViewAsBanner } from './ViewAsBanner';
import { useViewAs } from './useViewAs';
import { useViewAsSessionCheck } from './useViewAsSessionCheck';

export const ViewAsFrame: React.FC<{ readonly children: React.ReactNode }> = ({ children }) => {
  const viewAs = useViewAs();
  useViewAsSessionCheck();

  return (
    <div data-testid="view-as-frame" style={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}>
      {viewAs.isActive && <ViewAsBanner viewAs={viewAs} />}
      <div className="view-as-frame-content" style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {children}
      </div>
    </div>
  );
};
